import { render, staticRenderFns } from "./gasClamp_combinedV2.vue?vue&type=template&id=2abf3be7&scoped=true"
import script from "./gasClamp_combinedV2.vue?vue&type=script&lang=js"
export * from "./gasClamp_combinedV2.vue?vue&type=script&lang=js"
import style0 from "./gasClamp_combinedV2.vue?vue&type=style&index=0&id=2abf3be7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abf3be7",
  null
  
)

export default component.exports